"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isRTL = function isRTL(props) {
  return false;
};
var reverseTransform = "scale(-1, 1)";

var SvgStrikethrough = function SvgStrikethrough(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return _react2.default.createElement(
    "svg",
    Object.assign({
      viewBox: "0 0 512 512",
      width: "1em",
      height: "1em",
      transform: isRTL(props) ? reverseTransform : null,
      ref: svgRef
    }, props),
    _react2.default.createElement("path", { d: "M150.39 208h113.17l-46.31-23.16a45.65 45.65 0 010-81.68A67.93 67.93 0 01247.56 96H310a45.59 45.59 0 0136.49 18.25l15.09 20.13a16 16 0 0022.4 3.21l25.62-19.19a16 16 0 003.21-22.4L397.7 75.84A109.44 109.44 0 00310.1 32h-62.54a132.49 132.49 0 00-58.94 13.91c-40.35 20.17-64.19 62.31-60.18 108 1.76 20.09 10.02 38.37 21.95 54.09zM496 240H16a16 16 0 00-16 16v16a16 16 0 0016 16h480a16 16 0 0016-16v-16a16 16 0 00-16-16zm-92.5 80h-91.07l14.32 7.16a45.65 45.65 0 010 81.68 67.93 67.93 0 01-30.31 7.16H234a45.59 45.59 0 01-36.49-18.25l-15.09-20.13a16 16 0 00-22.4-3.21L134.4 393.6a16 16 0 00-3.21 22.4l15.11 20.17A109.44 109.44 0 00233.9 480h62.54a132.42 132.42 0 0058.93-13.91c40.36-20.17 64.2-62.31 60.19-108-1.19-13.69-5.89-26.27-12.06-38.09z" })
  );
};

var ForwardRef = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(SvgStrikethrough, Object.assign({ svgRef: ref }, props));
});
exports.default = ForwardRef;